export default class QueryOrderByItem
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryOrderByItem";

	tableId;	//String
	fieldId;	//String
	fieldName;	//String
	fieldType;	//String

	orderBy;	//String			//QueryOrderByType

}


// WEBPACK FOOTER //
// ./src/query/remote/QueryOrderByItem.js